var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.text)+" "),_c('v-progress-circular',{staticClass:"ml-5",attrs:{"rotate":360,"size":45,"width":5,"value":_vm.value,"color":"white"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }